import React from "react";
import {Toaster, ToasterProps} from "sonner";
import {Colors} from "../../colors";

export type ToastProps = ToasterProps;

export const Toast = ({position = "top-right", toastOptions, ...props}: ToastProps) => {
  return (
    <>
      <style>{`
        [data-sonner-toast][data-type="success"] {
          color: ${Colors.green._900};
        }
        [data-sonner-toast][data-type="error"] {
          color: ${Colors.red._900};
        }
        [data-sonner-toast] [data-close-button] {
          background: transparent;
          border: none;
          color: inherit;
        }
        [data-sonner-toast][data-styled=true] [data-title] {
          line-height: 1.3;
        }
      `}</style>
      <Toaster
        position={position}
        closeButton
        expand
        toastOptions={{
          ...toastOptions,
          style: {
            padding: "16px",
            borderRadius: "8px",
            lineHeight: 1.2,
            ...toastOptions?.style,
          },
        }}
        {...props}
      />
    </>
  );
};

export default Toast;
